var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16V14.6892L1.64178 13.0699C5.65079 9.29156 7.4453 7.24819 7.4453 4.85783C7.4453 3.27711 6.68168 1.77349 4.39082 1.77349C2.97812 1.77349 1.7945 2.50602 1.06906 3.08434L0.38181 1.58072C1.45088 0.655421 2.97812 0 4.77263 0C8.13256 0 9.50707 2.31325 9.50707 4.5494C9.50707 7.47952 7.40711 9.83133 4.16173 12.9928L2.93994 14.1494C2.93994 14.188 9.92706 14.188 9.92706 14.188V15.9614H0V16Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.f98d52a9da02abcf79b5da026bc20670.svg";
export { ForwardRef as ReactComponent };